import TwoFactorView from "./TwoFactorView";
export default TwoFactorView;